<template>
  <div class="alipay-container">
    <!-- 面包屑导航 -->
    <div class="breadcrumb-wrapper">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/Welcome' }">
          <i class="el-icon-s-home"></i> 首页
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <i class="el-icon-folder"></i> 文章分类
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <!-- 卡片内容 -->
    <el-card class="alipay-card" shadow="never">
      <!-- 搜索栏 -->
      <div class="search-bar">
        <el-form :inline="true" :model="searchForm" size="small">
          <el-form-item label="分类名称">
            <el-input 
              v-model="searchForm.name" 
              placeholder="请输入分类名称"
              prefix-icon="el-icon-search"
              clearable
              class="search-input"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="searchSubmit" icon="el-icon-search">搜索</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="success" @click="addData" icon="el-icon-plus">新增分类</el-button>
          </el-form-item>
        </el-form>
      </div>

      <!-- 统计卡片 -->
      <div class="stat-cards">
        <div class="stat-card">
          <div class="stat-icon total">
            <i class="el-icon-folder"></i>
          </div>
          <div class="stat-info">
            <div class="stat-value">{{ totalCount }}</div>
            <div class="stat-label">全部分类</div>
          </div>
        </div>
        <div class="stat-card">
          <div class="stat-icon level">
            <i class="el-icon-share"></i>
          </div>
          <div class="stat-info">
            <div class="stat-value">{{ levelCount }}</div>
            <div class="stat-label">多级分类</div>
          </div>
        </div>
      </div>

      <!-- 表格 -->
      <div class="table-wrapper">
        <el-table
          ref="multipleTable"
          :data="tableLoadData"
          stripe
          border
          row-key="id"
          :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
          size="medium"
          :header-cell-style="headerCellStyle"
          :row-style="rowStyle"
          v-loading="loading"
          element-loading-text="加载中..."
        >
          <el-table-column :index="indexMethod" type="index" label="序号" width="60" align="center"></el-table-column>
          
          <el-table-column label="分类名称" prop="name" min-width="250">
            <!-- <template slot-scope="scope">
              <div class="category-name">
                <i class="el-icon-folder"></i>
                <span>{{ scope.row.name }}</span>
                <el-tag v-if="scope.row.pid === 0" size="small" type="success" effect="plain" class="level-tag">顶级</el-tag>
              </div>
            </template> -->
          </el-table-column>
          
          <el-table-column label="分类编码" prop="sn" width="150" align="center">
            <template slot-scope="scope">
              <span class="sn-text">{{ scope.row.sn || '-' }}</span>
            </template>
          </el-table-column>
          
          <el-table-column label="上级分类" width="180" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.parent_name" class="parent-name">
                <i class="el-icon-back"></i>
                {{ scope.row.parent_name }}
              </span>
              <span v-else class="empty-text">顶级分类</span>
            </template>
          </el-table-column>
          
          <el-table-column label="创建时间" width="180" align="center">
            <template slot-scope="scope">
              <span class="time-text">{{ scope.row.add_time | dateFormat }}</span>
            </template>
          </el-table-column>
          
          <el-table-column label="操作" width="140" align="center" fixed="right">
            <template slot-scope="scope">
              <el-button 
                type="text" 
                size="small" 
                class="edit-btn"
                @click="handelEdit(scope.row)"
              >
                <i class="el-icon-edit-outline"></i> 编辑
              </el-button>
              <el-button 
                type="text" 
                size="small" 
                class="delete-btn"
                @click="del(scope.row)"
              >
                <i class="el-icon-delete"></i> 删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 空状态 -->
      <div v-if="tableLoadData.length === 0 && !loading" class="empty-state">
        <i class="el-icon-folder-opened"></i>
        <p>暂无分类数据</p>
        <el-button type="primary" size="small" @click="addData">立即添加</el-button>
      </div>

      <!-- 分页 -->
      <div class="pagination-wrapper" v-if="total > 0">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNum"
          :page-sizes="[10, 20, 30, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          :pager-count="5"
        >
        </el-pagination>
      </div>
    </el-card>

    <!-- 新增编辑弹框 -->
    <el-dialog 
      :title="dialogTitle" 
      :visible.sync="dialogFormVisible" 
      width="500px"
      :close-on-click-modal="false"
      class="alipay-dialog"
      @closed="handleDialogClosed"
    >
      <div class="dialog-content">
        <el-form :model="ruleForm" :rules="rules" ref="form" label-width="100px" label-position="right">
          <el-form-item label="分类名称" prop="name">
            <el-input 
              v-model="ruleForm.name" 
              placeholder="请输入分类名称"
              prefix-icon="el-icon-folder"
              clearable
              maxlength="30"
              show-word-limit
            ></el-input>
          </el-form-item>

          <el-form-item label="分类编码" prop="sn">
            <el-input 
              v-model="ruleForm.sn" 
              placeholder="请输入分类编码"
              prefix-icon="el-icon-document"
              clearable
              maxlength="50"
            ></el-input>
            <div class="form-tip">
              <i class="el-icon-info"></i> 分类编码用于程序识别，建议使用英文或数字
            </div>
          </el-form-item>

          <el-form-item label="上级分类">
            <el-select 
              v-model="ruleForm.parent_id" 
              placeholder="请选择上级分类（不选则为顶级分类）"
              clearable
              class="full-width"
            >
              <el-option 
                label="顶级分类" 
                :value="0"
              ></el-option>
              <el-option 
                v-for="item in cateMenus" 
                :key="item.id" 
                :label="getCategoryLabel(item)" 
                :value="item.id"
                :disabled="item.id === ruleForm.id"
              ></el-option>
            </el-select>
            <div class="form-tip" v-if="!ruleForm.parent_id || ruleForm.parent_id === 0">
              <i class="el-icon-info"></i> 不选择上级分类将创建为顶级分类
            </div>
          </el-form-item>
        </el-form>
      </div>
      
      <div slot="footer" class="dialog-footer">
        <el-button size="medium" @click="cancelForm">取 消</el-button>
        <el-button size="medium" type="primary" @click="submitForm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: "categoryList",
  data() {
    return {
      loading: false,
      
      // 搜索表单
      searchForm: {
        name: "",
      },
      
      // 统计数据
      totalCount: 0,
      levelCount: 0,
      
      // 表格数据
      tableLoadData: [],
      pageNum: 1,
      pageSize: 10,
      total: 0,
      
      showType: '',
      
      // 弹框控制
      dialogFormVisible: false,
      dialogTitle: '',
      
      // 表单数据
      ruleForm: {
        name: '',
        parent_id: '',
        id: '',
        sn: ""
      },
      
      // 分类菜单树（用于选择上级分类）
      cateMenus: [],
      
      // 验证规则
      rules: {
        name: [
          { required: true, message: '请输入分类名称', trigger: 'blur' },
          { min: 2, max: 30, message: '长度在 2 到 30 个字符', trigger: 'blur' }
        ],
        sn: [
          { max: 50, message: '长度不能超过50个字符', trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    this.showType = this.$route.query.showType
    this.DataList()
    this.getCateMenus()
  },
  filters: {
    dateFormat(add_time) {
      if (!add_time) return ""
      return moment(add_time * 1000).format("YYYY-MM-DD HH:mm:ss")
    }
  },
  methods: {
    // 表格样式配置
    headerCellStyle() {
      return {
        background: '#f5f7fa',
        color: '#1f2d3d',
        fontWeight: '500',
        fontSize: '14px',
        borderBottom: '1px solid #e4e7ed'
      }
    },
    
    rowStyle() {
      return {
        cursor: 'pointer'
      }
    },
    
    // 获取分类标签（带缩进显示层级）
    getCategoryLabel(item) {
      let prefix = ''
      if (item.level > 0) {
        prefix = '|— ' + '　'.repeat(item.level)
      }
      return prefix + item.name
    },
    
    // 计算统计数据
    calculateStats() {
      const countCategories = (data) => {
        let count = data.length
        for (const item of data) {
          if (item.children && item.children.length) {
            count += countCategories(item.children)
          }
        }
        return count
      }
      
      this.totalCount = countCategories(this.tableLoadData)
      
      // 计算多级分类数量（有子分类的）
      const countLevel = (data) => {
        let count = 0
        for (const item of data) {
          if (item.children && item.children.length) {
            count++
            count += countLevel(item.children)
          }
        }
        return count
      }
      this.levelCount = countLevel(this.tableLoadData)
    },
    
    indexMethod(index) {
      return (this.pageNum - 1) * this.pageSize + index + 1
    },
    
    // 获取分类菜单（用于选择上级分类）
    getCateMenus() {
      let _this = this
      let params = {
        access_token: sessionStorage.getItem('token'),
        company_id: sessionStorage.getItem('company_id'),
      }
      this.$axios.newsCatetory(params).then((res) => {
        if (res.code == 200) {
          _this.cateMenus = _this.flattenTree(res.data)
        }
      })
    },
    
    // 将树形结构扁平化（用于下拉选择）
    flattenTree(tree, level = 0) {
      let result = []
      for (const node of tree) {
        node.level = level
        result.push(node)
        if (node.children && node.children.length) {
          result = result.concat(this.flattenTree(node.children, level + 1))
        }
      }
      return result
    },
    
    // 获取分类列表
    DataList() {
      this.loading = true
      const param = {
        company_id: sessionStorage.getItem('company_id'),
        access_token: sessionStorage.getItem('token'),
        showType: this.showType
      }
      
      if (this.searchForm.name) {
        param.name = this.searchForm.name
      }
      
      this.$axios.newsCatetory(param).then(res => {
        this.loading = false
        if (res.code == 200) {
          this.tableLoadData = res.data || []
          this.total = this.tableLoadData.length
          this.calculateStats()
        }
      }).catch(error => {
        this.loading = false
        console.log(error)
      })
    },
    
    handleSizeChange(newSize) {
      this.pageSize = newSize
      this.pageNum = 1
      this.DataList()
    },
    
    handleCurrentChange(newPage) {
      this.pageNum = newPage
      this.DataList()
    },
    
    searchSubmit() {
      this.pageNum = 1
      this.DataList()
    },
    
    // 新增分类
    addData() {
      this.dialogTitle = '新增分类'
      this.ruleForm = {
        id: '',
        name: '',
        sn: '',
        parent_id: ''
      }
      this.dialogFormVisible = true
    },
    
    // 编辑分类
    handelEdit(row) {
      this.dialogTitle = '编辑分类'
      this.ruleForm = {
        id: row.id,
        name: row.name,
        sn: row.sn || '',
        parent_id: row.pid || ''
      }
      this.dialogFormVisible = true
    },
    
    // 删除分类
    del(row) {
      let message = `确定要删除分类"${row.name}"吗？`
      if (row.children && row.children.length) {
        message = `分类"${row.name}"下有 ${row.children.length} 个子分类，删除后所有子分类也将被删除，是否继续？`
      }
      
      this.$confirm(message, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        const param = {
          company_id: sessionStorage.getItem('company_id'),
          access_token: sessionStorage.getItem('token'),
          id: row.id,
        }
        this.$axios.delNewsCatetory(param).then(res => {
          if (res.code == 200) {
            this.$message.success(res.msg)
            this.getCateMenus()
            this.DataList()
          } else {
            this.$message.error(res.msg)
          }
        }).catch(error => {
          console.log(error)
          this.$message.error('删除失败')
        })
      }).catch(() => {
        this.$message.info('已取消删除')
      })
    },
    
    // 弹框关闭回调
    handleDialogClosed() {
      this.$refs.form?.resetFields()
    },
    
    // 取消表单
    cancelForm() {
      this.dialogFormVisible = false
    },
    
    // 提交表单
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          const param = {
            name: this.ruleForm.name,
            id: this.ruleForm.id,
            parent_id: this.ruleForm.parent_id || 0,
            sn: this.ruleForm.sn,
            company_id: sessionStorage.getItem('company_id'),
            access_token: sessionStorage.getItem('token'),
          }
          
          this.$axios.saveNewsCatetory(param).then(res => {
            if (res.code == 200) {
              this.$message.success(res.msg)
              this.getCateMenus()
              this.DataList()
              this.dialogFormVisible = false
            } else {
              this.$message.error(res.msg)
            }
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.alipay-container {
  padding: 16px 20px;
  background: #f5f7fa;
  min-height: calc(100vh - 60px);
}

// 面包屑样式
.breadcrumb-wrapper {
  margin-bottom: 16px;
  
  .el-breadcrumb {
    font-size: 14px;
    
    i {
      margin-right: 4px;
    }
  }
}

// 卡片样式
.alipay-card {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  
  &:hover {
    box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.08);
  }
}

.alipay-card .el-card__body {
  padding: 20px 24px;
}

// 搜索栏样式
.search-bar {
  background: #f8f9fc;
  padding: 16px 20px;
  border-radius: 12px;
  margin-bottom: 20px;
  
  .el-form-item {
    margin-bottom: 0;
  }
  
  .search-input {
    width: 240px;
  }
  
  .search-input .el-input__inner {
    border-radius: 20px;
  }
  
  .el-button--primary {
    background: #1677ff;
    border-color: #1677ff;
    border-radius: 20px;
    padding: 8px 20px;
    
    &:hover {
      background: #4096ff;
      border-color: #4096ff;
    }
  }
  
  .el-button--success {
    background: #00b578;
    border-color: #00b578;
    border-radius: 20px;
    padding: 8px 20px;
    
    &:hover {
      background: #1acd8c;
      border-color: #1acd8c;
    }
  }
}

// 统计卡片样式
.stat-cards {
  display: flex;
  gap: 20px;
  margin-bottom: 24px;
  flex-wrap: wrap;
  
  .stat-card {
    flex: 1;
    min-width: 160px;
    background: linear-gradient(135deg, #fff 0%, #f8f9fc 100%);
    border-radius: 16px;
    padding: 20px;
    display: flex;
    align-items: center;
    gap: 16px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
    transition: all 0.3s ease;
    
    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
    }
    
    .stat-icon {
      width: 48px;
      height: 48px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 24px;
      color: #fff;
      
      &.total {
        background: linear-gradient(135deg, #1677ff, #4096ff);
      }
      
      &.level {
        background: linear-gradient(135deg, #00b578, #1acd8c);
      }
    }
    
    .stat-info {
      .stat-value {
        font-size: 28px;
        font-weight: 700;
        color: #1f2d3d;
        line-height: 1.2;
      }
      
      .stat-label {
        font-size: 13px;
        color: #8c8f98;
        margin-top: 4px;
      }
    }
  }
}

// 表格样式
.table-wrapper {
  margin-bottom: 20px;
  min-height: 350px;
}

.el-table {
  border-radius: 12px;
  overflow: hidden;
}

.el-table::before {
  display: none;
}

.el-table th {
  background: #fafbfc !important;
  font-weight: 500;
}

.el-table td {
  border-bottom: 1px solid #f0f0f0;
}

.el-table .el-table__row {
  transition: background 0.2s;
}

.el-table .el-table__row:hover {
  background: #f8f9fc;
}

.category-name {
  display: flex;
  align-items: center;
  gap: 8px;
  
  i {
    font-size: 16px;
    color: #e6a23c;
  }
  
  span {
    font-weight: 500;
    color: #1f2d3d;
  }
  
  .level-tag {
    margin-left: 8px;
  }
}

.sn-text {
  font-family: monospace;
  font-size: 12px;
  color: #1677ff;
}

.parent-name {
  display: flex;
  align-items: center;
  gap: 4px;
  
  i {
    font-size: 12px;
    color: #909399;
  }
}

.time-text {
  font-size: 12px;
  color: #8c8f98;
}

.empty-text {
  color: #c0c4cc;
  font-size: 12px;
}

.edit-btn {
  color: #1677ff;
  margin-right: 12px;
  
  i {
    margin-right: 4px;
  }
  
  &:hover {
    color: #4096ff;
  }
}

.delete-btn {
  color: #ff4d4f;
  
  i {
    margin-right: 4px;
  }
  
  &:hover {
    color: #ff7875;
  }
}

// 空状态样式
.empty-state {
  text-align: center;
  padding: 60px 20px;
  color: #c0c4cc;
  
  i {
    font-size: 64px;
  }
  
  p {
    margin-top: 16px;
    font-size: 14px;
  }
  
  .el-button {
    margin-top: 20px;
    border-radius: 20px;
  }
}

// 分页样式
.pagination-wrapper {
  display: flex;
  justify-content: flex-end;
  padding-top: 16px;
  border-top: 1px solid #f0f0f0;
}

.el-pagination .el-pager li.active {
  background: #1677ff;
  color: #fff;
}

.el-pagination .el-pagination__total {
  color: #8c8f98;
}

// 弹框样式
.alipay-dialog .el-dialog {
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.08);
}

.alipay-dialog .el-dialog__header {
  background: linear-gradient(135deg, #1677ff 0%, #4096ff 100%);
  padding: 20px 24px;
}

.alipay-dialog .el-dialog__title {
  color: #fff;
  font-size: 18px;
  font-weight: 500;
}

.alipay-dialog .el-dialog__headerbtn .el-dialog__close {
  color: #fff;
  font-size: 18px;
}

.alipay-dialog .el-dialog__headerbtn .el-dialog__close:hover {
  color: rgba(255, 255, 255, 0.8);
}

.alipay-dialog .el-dialog__body {
  padding: 24px;
}

.alipay-dialog .el-dialog__footer {
  padding: 16px 24px 24px;
  border-top: 1px solid #f0f0f0;
}

.dialog-content .el-form-item {
  margin-bottom: 22px;
}

.dialog-content .el-form-item .el-form-item__label {
  font-weight: 500;
  color: #1f2d3d;
}

.dialog-content .el-input__inner,
.dialog-content .el-textarea__inner,
.dialog-content .el-select .el-input__inner {
  border-radius: 8px;
  border-color: #e4e7ed;
  transition: all 0.2s;
}

.dialog-content .el-input__inner:focus,
.dialog-content .el-textarea__inner:focus,
.dialog-content .el-select .el-input__inner:focus {
  border-color: #1677ff;
  box-shadow: 0 0 0 2px rgba(22, 119, 255, 0.1);
}

.full-width {
  width: 100%;
}

.form-tip {
  margin-top: 6px;
  font-size: 12px;
  color: #8c8f98;
  
  i {
    margin-right: 4px;
    color: #1677ff;
  }
}

.dialog-footer {
  .el-button {
    border-radius: 20px;
    padding: 9px 24px;
  }
  
  .el-button--primary {
    background: #1677ff;
    border-color: #1677ff;
  }
  
  .el-button--primary:hover {
    background: #4096ff;
    border-color: #4096ff;
  }
}
</style>